module.exports = __webpack_public_path__ + "static/img/chufang.d5ea11dc.png";